(function () {
  // Back-in-stock notify: intercepts Concept theme's notify contact form and
  // subscribes the visitor to a Klaviyo back-in-stock alert for the selected variant.
  var COMPANY_ID = 'T7gpbq';
  var REVISION = '2024-10-15';

  function getVariantId() {
    var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return idInput ? idInput.value : null;
  }

  function subscribe(email, variantId) {
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    });
  }

  function identify(email, name) {
    try {
      if (!window.klaviyo || !name) return;
      var parts = name.trim().split(/\s+/);
      var props = { email: email, first_name: parts.shift() };
      if (parts.length) props.last_name = parts.join(' ');
      window.klaviyo.identify(props);
    } catch (err) { /* best-effort only */ }
  }

  function showSuccess(form) {
    var msg = document.createElement('p');
    msg.className = 'birs-success h6';
    msg.textContent = "You're on the list! We'll email you as soon as it's back in stock.";
    msg.style.cssText = 'padding:0.75rem 0;font-weight:600;';
    form.parentNode.insertBefore(msg, form);
    form.style.display = 'none';
  }

  function showError(form) {
    var msg = form.querySelector('.birs-error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'birs-error';
      msg.style.cssText = 'padding:0.5rem 0;color:#b00020;font-size:0.85em;';
      form.appendChild(msg);
    }
    msg.textContent = "Hmm, that didn't go through. Click the button again and we'll take your request by message instead.";
  }

  var LIST_ID = 'RdnKfJ';
  // Pre-ticked consent is permissible under CAN-SPAM (US) but not under GDPR
  // (EU/UK) or CASL (CA), so only default it on where it is allowed.
  var EXPRESS_CONSENT = /^(AT|BE|BG|HR|CY|CZ|DK|EE|FI|FR|DE|GR|HU|IE|IT|LV|LT|LU|MT|NL|PL|PT|RO|SK|SI|ES|SE|GB|CA|NO|IS|LI|CH)$/;

  function preChecked() {
    var c = (window.Shopify && window.Shopify.country) || '';
    return !EXPRESS_CONSENT.test(String(c).toUpperCase());
  }

  function ensureConsentCss() {
    if (document.getElementById('birs-consent-css')) return;
    var st = document.createElement('style');
    st.id = 'birs-consent-css';
    // Theme sets appearance:none on inputs, stripping native checkbox chrome and
    // leaving a solid dark block, so draw the box and tick ourselves.
    st.textContent = '.birs-consent-input{-webkit-appearance:none!important;appearance:none!important;'
      + 'width:18px!important;height:18px!important;min-width:18px!important;flex:0 0 18px!important;'
      + 'margin:2px 0 0!important;padding:0!important;border:1.5px solid #B9B6AF!important;'
      + 'border-radius:4px!important;background:#fff!important;box-shadow:none!important;'
      + 'cursor:pointer!important;position:relative!important;}'
      + '.birs-consent-input:checked{background:#5FCE7B!important;border-color:#5FCE7B!important;}'
      + '.birs-consent-input:checked::after{content:"";position:absolute;left:5px;top:1px;'
      + 'width:5px;height:9px;border:solid #173404;border-width:0 2px 2px 0;transform:rotate(45deg);}';
    document.head.appendChild(st);
  }

  function addConsentBox(form) {
    if (form.querySelector('.birs-consent')) return;
    var wrap = document.createElement('label');
    wrap.className = 'birs-consent';
    wrap.setAttribute('style', 'display:flex;gap:9px;align-items:flex-start;margin:12px 0 18px;font-size:14px;line-height:1.45;cursor:pointer;');
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.className = 'birs-consent-input';
    cb.checked = preChecked();
    ensureConsentCss();
    var txt = document.createElement('span');
    txt.textContent = 'Notify me of new product releases.';
    wrap.appendChild(cb); wrap.appendChild(txt);
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.parentNode) { btn.parentNode.insertBefore(wrap, btn); }
    else { form.appendChild(wrap); }
  }

  function subscribeToList(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/' + '?' + 'company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Back in Stock',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: LIST_ID } } }
        }
      })
    }).catch(function () {});
  }

  function init() {
    var tas = document.querySelectorAll('textarea[name="contact[Back-in-stock alert]"]');
    for (var i = 0; i < tas.length; i++) {
      var form = tas[i].closest('form');
      if (!form || form.dataset.birsBound) continue;
      form.dataset.birsBound = '1';
      addConsentBox(form);
      form.addEventListener('submit', function (e) {
        var f = e.currentTarget;
        if (f.dataset.birsSkip) return; // fall through to native contact submit (with Shopify captcha)
        var emailInput = f.querySelector('input[name="contact[email]"], input[type="email"]');
        var email = emailInput && emailInput.value.trim();
        var nameInput = f.querySelector('input[name="contact[name]"]');
        var consent = f.querySelector('.birs-consent-input');
        var variantId = getVariantId();
        if (!email || !variantId) return;
        e.preventDefault();
        var btn = f.querySelector('[type="submit"]');
        var btnText = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Submitting...'; }
        subscribe(email, variantId)
          .then(function (res) {
            if (res.ok) {
              identify(email, nameInput ? nameInput.value : '');
              if (consent && consent.checked) { subscribeToList(email); }
              showSuccess(f);
            } else { throw new Error('BIS ' + res.status); }
          })
          .catch(function () {
            f.dataset.birsSkip = '1';
            if (btn) { btn.disabled = false; btn.textContent = btnText; }
            showError(f);
          });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
